var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.35C4.39099 17.35 0.65 13.609 0.65 9C0.65 4.39099 4.39099 0.65 9 0.65C13.609 0.65 17.35 4.39099 17.35 9C17.35 13.609 13.609 17.35 9 17.35ZM9.33362 12.2856L11.8446 9.77462C12.2778 9.34141 12.261 8.64177 11.8356 8.21638L9.32761 5.70837C8.63455 5 7.45 5.50308 7.45 6.48L7.45 11.511C7.45 12.5088 8.64584 12.9734 9.33362 12.2856Z",
    stroke: "#C2CFE0",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotions);
export default __webpack_public_path__ + "static/media/motions.080d96fc844c33f5848daa5db4e457fc.svg";
export { ForwardRef as ReactComponent };